import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type alertCountDataDetails } from '../services/getAlertCoutDataService'

export interface AlertCountDataState {
  isLoading: boolean
  errorMessage: string | null
  AlertCountDataAssetDashboard: alertCountDataDetails | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: AlertCountDataState = {
  AlertCountDataAssetDashboard: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const AlertCountGraphDataState = createSlice({
  name: 'AlertCountGraphDataState',
  initialState,
  reducers: {
    AlertCountDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        AlertCountDataAssetDashboard: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    AlertCountDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        AlertCountDataAssetDashboard: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    AlertCountDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        AlertCountDataAssetDashboard: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    },
    activeAlertCountSocketUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        AlertCountDataAssetDashboard: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  AlertCountDataLoadingAction,
  AlertCountDataUpdateAction,
  AlertCountDataErrorAction,
  activeAlertCountSocketUpdateAction
} = AlertCountGraphDataState.actions

export default AlertCountGraphDataState.reducer
